import React from "react";
import styled from "styled-components";
import NoFooterModal from "../../Common/NoFooterModal";
import Button from "sushiweb/Button";
import { BottomSectionModal } from "../../../constants/assets/containers";

const ErrorModal = ({ handleSubmit, errors, subHeading, heading }) => {
  return (
    <ErrorModalContainer>
      <NoFooterModal
        header
        heading={heading || "Save Changes"}
        handleClose={handleSubmit}
        id="errorModal"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="confirm-btn"
              onClick={handleSubmit}
              className="sushi-btn"
            >
              {"Okay"}
            </Button>
          </BottomSectionModal>
        }
      >
        <p>{subHeading || "Resolve the below issues before saving -"}</p>
        <ul>
          {errors.map((err, idx) => {
            return (
              <li key={idx} className="semibold">
                {err}
              </li>
            );
          })}
        </ul>
      </NoFooterModal>
    </ErrorModalContainer>
  );
};

const ErrorModalContainer = styled.section`
  li {
    line-height: 30px;
  }
`;

export default ErrorModal;
